(function () {
  'use strict';

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function truncateWords(text, limit) {
    var words = String(text == null ? '' : text)
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter(Boolean);
    if (!words.length) return '';
    if (words.length <= limit) return words.join(' ');
    return words.slice(0, limit).join(' ') + '...';
  }

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatDate(iso) {
    if (!iso) return { display: '', machine: '' };
    var d = new Date(iso);
    if (isNaN(d.getTime())) return { display: '', machine: '' };
    return {
      display: MONTHS[d.getMonth()] + ' ' + pad2(d.getDate()) + ', ' + d.getFullYear(),
      machine: d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()),
    };
  }

  function buildSearchQuery(blogTitle, tag) {
    var parts = [];
    if (blogTitle) parts.push("blog_title:'" + blogTitle.replace(/(['\\])/g, '\\$1') + "'");
    if (tag) parts.push("tag:'" + tag.replace(/(['\\])/g, '\\$1') + "'");
    return parts.join(' AND ');
  }

  function getConfig(main) {
    var perPage = parseInt(main.getAttribute('data-sbcp-per-page'), 10);
    var excerptWords = parseInt(main.getAttribute('data-sbcp-excerpt-words'), 10);
    var imageWidth = parseInt(main.getAttribute('data-sbcp-image-width'), 10);
    return {
      shop: main.getAttribute('data-sbcp-shop'),
      version: main.getAttribute('data-sbcp-version') || '2024-10',
      token: main.getAttribute('data-sbcp-token') || window.SF_API_TOKEN,
      blogHandle: main.getAttribute('data-sbcp-blog-handle') || '',
      blogTitle: main.getAttribute('data-sbcp-blog-title') || '',
      tag: main.getAttribute('data-sbcp-tag') || '',
      perPage: Number.isInteger(perPage) && perPage > 0 ? perPage : 12,
      excerptWords: Number.isInteger(excerptWords) && excerptWords > 0 ? excerptWords : 28,
      imageWidth: Number.isInteger(imageWidth) && imageWidth > 0 ? imageWidth : 900,
      showAuthor: main.getAttribute('data-sbcp-show-author') === 'true',
      showDate: main.getAttribute('data-sbcp-show-date') === 'true',
      pageUrl: main.getAttribute('data-sbcp-page-url') || window.location.pathname,
      prevLabel: main.getAttribute('data-sbcp-prev-label') || '\u00ab Previous',
      nextLabel: main.getAttribute('data-sbcp-next-label') || 'Next \u00bb',
    };
  }

  var ARTICLES_QUERY =
    'query SbcpArticles($q: String!, $n: Int!, $after: String) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q, after: $after) {' +
    '    edges { node {' +
    '      title handle onlineStoreUrl publishedAt' +
    '      excerpt content(truncateAt: 400)' +
    '      image { url altText }' +
    '      authorV2 { name }' +
    '      authorMeta: metafield(namespace: "custom", key: "author") {' +
    '        reference { ... on Metaobject { authorName: field(key: "name") { value } } }' +
    '      }' +
    '    } }' +
    '    pageInfo { hasNextPage endCursor }' +
    '  }' +
    '}';

  function sfRequest(config, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    if (!config.shop || !config.token) return Promise.resolve(null);
    var endpoint = 'https://' + config.shop + '/api/' + config.version + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.token },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function fetchAllArticles(config) {
    var q = buildSearchQuery(config.blogTitle, config.tag);
    var collected = [];

    function page(after, guard) {
      if (guard > 50) return Promise.resolve(collected);
      return sfRequest(config, ARTICLES_QUERY, { q: q, n: 100, after: after }).then(function (json) {
        var conn = json && json.data && json.data.articles;
       
        if (!conn) return guard === 0 ? null : collected;
        (conn.edges || []).forEach(function (edge) {
          if (edge && edge.node) collected.push(edge.node);
        });
        var info = conn.pageInfo || {};
        if (info.hasNextPage && info.endCursor) return page(info.endCursor, guard + 1);
        return collected;
      });
    }

    return page(null, 0);
  }

  function imageMarkup(node, config) {
    if (!node.image || !node.image.url) {
      return '<span class="sbcp-card__image-placeholder" aria-hidden="true"></span>';
    }
    var alt = node.image.altText || node.title || '';
    var widths = [400, 600, 800, 900];
    var srcset = widths
      .map(function (w) { return esc(withWidth(node.image.url, w)) + ' ' + w + 'w'; })
      .join(', ');
    return (
      '<img class="sbcp-card__image" src="' + esc(withWidth(node.image.url, config.imageWidth)) + '"' +
      ' srcset="' + srcset + '" sizes="(min-width: 769px) 50vw, 100vw"' +
      ' loading="lazy" alt="' + esc(alt) + '">'
    );
  }

  function metaMarkup(node, config) {
    if (!config.showAuthor && !config.showDate) return '';
    var metaAuthor =
      node.authorMeta &&
      node.authorMeta.reference &&
      node.authorMeta.reference.authorName &&
      node.authorMeta.reference.authorName.value;
    var author = metaAuthor || (node.authorV2 && node.authorV2.name ? node.authorV2.name : '');
    var date = formatDate(node.publishedAt);
    var hasAuthor = config.showAuthor && author;
    var pieces = '';
    if (hasAuthor) pieces += esc(author);
    if (hasAuthor && config.showDate) pieces += '<span class="sbcp-card__meta-sep" aria-hidden="true"> / </span>';
    if (config.showDate && date.display) {
      pieces += '<time datetime="' + esc(date.machine) + '">' + esc(date.display) + '</time>';
    }
    if (!pieces) return '';
    return '<p class="sbcp-card__meta">' + pieces + '</p>';
  }

  function cardMarkup(node, config) {
    var url = node.onlineStoreUrl || '/blogs/' + config.blogHandle + '/' + node.handle;
    var excerptSource = node.excerpt || node.content || '';
    var titleMarkup = node.title
      ? '<h2 class="sbcp-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h2>'
      : '';
    return (
      '<li class="sbcp-grid__item"><article class="sbcp-card">' +
      '<a href="' + esc(url) + '" class="sbcp-card__media">' + imageMarkup(node, config) + '</a>' +
      '<div class="sbcp-card__body">' +
      titleMarkup +
      metaMarkup(node, config) +
      '<p class="sbcp-card__excerpt">' + esc(truncateWords(excerptSource, config.excerptWords)) + '</p>' +
      '</div></article></li>'
    );
  }

  function pageHref(config, pageNum) {
    if (pageNum <= 1) return config.pageUrl;
    var sep = config.pageUrl.indexOf('?') > -1 ? '&' : '?';
    return config.pageUrl + sep + 'page=' + pageNum;
  }

  function paginationRange(currentPage, totalPages, siblings) {
    siblings = siblings || 1;
    var maxNumbers = siblings * 2 + 5;
    var i;

    if (totalPages <= maxNumbers) {
      var all = [];
      for (i = 1; i <= totalPages; i++) all.push(i);
      return all;
    }

    var leftSibling = Math.max(currentPage - siblings, 1);
    var rightSibling = Math.min(currentPage + siblings, totalPages);
    var showLeftDots = leftSibling > 2;
    var showRightDots = rightSibling < totalPages - 1;
    var edgeCount = 3 + siblings * 2; 
    var items = [];

    if (!showLeftDots && showRightDots) {
      for (i = 1; i <= edgeCount; i++) items.push(i);
      items.push('...');
      items.push(totalPages);
    } else if (showLeftDots && !showRightDots) {
      items.push(1);
      items.push('...');
      for (i = totalPages - edgeCount + 1; i <= totalPages; i++) items.push(i);
    } else {
      items.push(1);
      items.push('...');
      for (i = leftSibling; i <= rightSibling; i++) items.push(i);
      items.push('...');
      items.push(totalPages);
    }

    return items;
  }

  function pageItemMarkup(config, n, currentPage) {
    if (n === '...') {
      return (
        '<li class="sbcp-pagination__item">' +
        '<span class="sbcp-pagination__ellipsis" aria-hidden="true">\u2026</span></li>'
      );
    }
    if (n === currentPage) {
      return (
        '<li class="sbcp-pagination__item">' +
        '<span class="sbcp-pagination__link sbcp-pagination__link--current" aria-current="page">' +
        n + '</span></li>'
      );
    }
    return (
      '<li class="sbcp-pagination__item">' +
      '<a class="sbcp-pagination__link" href="' + esc(pageHref(config, n)) + '" data-sbcp-page="' + n +
      '" aria-label="Page ' + n + '">' + n + '</a></li>'
    );
  }

  function paginationMarkup(config, currentPage, totalPages) {
    if (totalPages <= 1) return '';
    var items = '';

    if (currentPage > 1) {
      items +=
        '<li class="sbcp-pagination__item">' +
        '<a class="sbcp-pagination__link sbcp-pagination__link--nav" href="' +
        esc(pageHref(config, currentPage - 1)) + '" data-sbcp-page="' + (currentPage - 1) + '" rel="prev">' +
        esc(config.prevLabel) + '</a></li>';
    }

    paginationRange(currentPage, totalPages, 1).forEach(function (n) {
      items += pageItemMarkup(config, n, currentPage);
    });

    if (currentPage < totalPages) {
      items +=
        '<li class="sbcp-pagination__item">' +
        '<a class="sbcp-pagination__link sbcp-pagination__link--nav" href="' +
        esc(pageHref(config, currentPage + 1)) + '" data-sbcp-page="' + (currentPage + 1) + '" rel="next">' +
        esc(config.nextLabel) + '</a></li>';
    }

    return '<ul class="sbcp-pagination__list" role="list">' + items + '</ul>';
  }

  function getUrlPage() {
    var raw = Number(new URLSearchParams(window.location.search).get('page'));
    if (!Number.isInteger(raw) || raw < 1) return 1;
    return raw;
  }

  function render(main, config, articles, requestedPage, replaceUrl) {
    var grid = main.querySelector('[data-sbcp-grid]');
    var nav = main.querySelector('[data-sbcp-pagination]');
    var empty = main.querySelector('[data-sbcp-empty]');

    if (!articles.length) {
      if (grid) grid.innerHTML = '';
      if (nav) { nav.hidden = true; nav.innerHTML = ''; }
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    var totalPages = Math.max(1, Math.ceil(articles.length / config.perPage));
    var currentPage = Math.max(1, Math.min(requestedPage || 1, totalPages));
    var start = (currentPage - 1) * config.perPage;
    var slice = articles.slice(start, start + config.perPage);

    if (grid) {
      grid.innerHTML = slice
        .map(function (node) { return cardMarkup(node, config); })
        .join('');
    }

    if (nav) {
      var markup = paginationMarkup(config, currentPage, totalPages);
      nav.innerHTML = markup;
      nav.hidden = !markup;
    }

    var params = new URLSearchParams(window.location.search);
    if (currentPage > 1) params.set('page', String(currentPage));
    else params.delete('page');
    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    var state = { sbcpPage: currentPage };
    if (replaceUrl) window.history.replaceState(state, '', nextUrl);
    else window.history.pushState(state, '', nextUrl);

    main.dataset.sbcpCurrentPage = String(currentPage);
  }

  function initMain(main) {
    if (!main || main.dataset.sbcpBound === 'true') return;
    main.dataset.sbcpBound = 'true';

    var config = getConfig(main);
    if (!config.tag) return; 

    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);
    if (!hasClient && (!config.shop || !config.token)) return;

    main.setAttribute('aria-busy', 'true');

    fetchAllArticles(config)
      .then(function (articles) {
        main.removeAttribute('aria-busy');
        if (!articles) return;

        var ordered = articles;

        render(main, config, ordered, getUrlPage(), true);

        main.addEventListener('click', function (event) {
          var link = event.target.closest('[data-sbcp-page]');
          if (!link || !main.contains(link)) return;
          event.preventDefault();
          var page = Number(link.getAttribute('data-sbcp-page'));
          if (!Number.isInteger(page) || page < 1) return;
          render(main, config, ordered, page, false);
          var top = main.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        window.addEventListener('popstate', function () {
          if (!document.body.contains(main)) return;
          render(main, config, ordered, getUrlPage(), true);
        });
      })
      .catch(function () {
        main.removeAttribute('aria-busy');
      });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sbcp-main]').forEach(initMain);
    if (scope.matches && scope.matches('[data-sbcp-main]')) initMain(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (root) boot(root);
  });
})();
